import { render, staticRenderFns } from "./staff_attendance.vue?vue&type=template&id=4066c33c&scoped=true&"
import script from "./staff_attendance.vue?vue&type=script&lang=js&"
export * from "./staff_attendance.vue?vue&type=script&lang=js&"
import style0 from "./staff_attendance.vue?vue&type=style&index=0&id=4066c33c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4066c33c",
  null
  
)

export default component.exports